// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vvIZx","payment":"styles_payment__iwOo+"};